import { getLocalizedLabel } from '../../../intl-helpers';

export const getAssetClassLabel = (key, attribute, lang = 'it_IT') => {
    if(!key) return '-'
    if(!attribute) return '-'
    if(!Array.isArray(attribute)) return '-'

    const match = attribute.find(asset => asset.code === key)
    return getLocalizedLabel(match?.label, lang) || '-'
}

export function getAssetLabel(assetClasses, code, lang = 'it_IT') {
    if (!Array.isArray(assetClasses)) return null;

    const match = assetClasses.find(cls => cls.code === code);
    return getLocalizedLabel(match?.label, lang) || null;
}
